/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { FormattedMessage } from 'react-intl'
import { Table } from '@mantine/core'
import NoData from '../../../../client/js/components/NoData'
import SelectionToggle from '../../../../client/js/components/selection/SelectionToggle'
import LeaseListItem from './LeaseListItem'

export type LeaseListProps = {
  items: Lease[]
}

function LeaseList (props: LeaseListProps) {
  const { items } = props
  return (
    <Table highlightOnHover>
      <Table.Thead>
        <Table.Tr>
          <Table.Th w={50}>
            <SelectionToggle />
          </Table.Th>
          <Table.Th w={120}>
            <FormattedMessage
              id="status"
              defaultMessage="État"
            />
          </Table.Th>
          <Table.Th w={200}>
            <FormattedMessage
              id="photo"
              defaultMessage="Photo"
            />
          </Table.Th>
          <Table.Th w={130}>
            <FormattedMessage
              id="reference"
              defaultMessage="Référence"
            />
          </Table.Th>
          <Table.Th>
            <FormattedMessage
              id="lessor"
              defaultMessage="Bailleur"
            />
          </Table.Th>
          <Table.Th>
            <FormattedMessage
              id="tenant"
              defaultMessage="Locataire"
            />
          </Table.Th>
          <Table.Th w={100} ta="end">
            <FormattedMessage
              id="rent"
              defaultMessage="Loyer"
            />
          </Table.Th>
          <Table.Th w={120}>
            <FormattedMessage
              id="start_date"
              defaultMessage="Date de début"
            />
          </Table.Th>
          <Table.Th w={200}>
            <FormattedMessage
              id="end_date"
              defaultMessage="Date de fin"
            />
          </Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {items.length > 0
          ? items.map((item) => (
            <LeaseListItem
              item={item}
              key={item.id}
            />
          ))
          : <Table.Tr>
            <Table.Td colSpan={11}>
              <NoData />
            </Table.Td>
          </Table.Tr>
        }
      </Table.Tbody>
    </Table>
  )
}

export default LeaseList
